export enum AgentId {
  NONE = 0,
  TRIAL_BALANCE = 10,
  COA_MAPPING = 20,
  ANOMALY_DETECTION = 50,
}
